import { get } from "@services/apiService.js";
export default {

  getGeneralConfigs() {
    return get(`/v4/user-preference/v1/general/configs`)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },

};
